import { MessageCircle } from "lucide-react";
import { useSettings, whatsappLink } from "@/context/SettingsContext";

export function WhatsAppButton({ message, label = "Order on WhatsApp", className = "", testId = "whatsapp-btn", variant = "solid" }) {
  const { settings } = useSettings();
  const href = whatsappLink(settings.whatsapp, message);

  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 font-medium transition-transform hover:-translate-y-0.5";
  const styles =
    variant === "outline"
      ? "border-2 border-[#25D366] text-[#128C4A] hover:bg-[#25D366]/10"
      : "bg-[#25D366] text-white hover:bg-[#1EBE5A] shadow-sm";

  return (
    <a
      data-testid={testId}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${styles} ${className}`}
    >
      <MessageCircle className="w-5 h-5" />
      {label}
    </a>
  );
}

export function FloatingWhatsApp() {
  const { settings } = useSettings();
  const href = whatsappLink(settings.whatsapp, `Hi ${settings.business_name || "Taanya Homefoods"}, I'd like to know more about your products.`);
  return (
    <a
      data-testid="floating-whatsapp"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
}
